import { Settings, HelpCircle } from 'lucide-react';
import './LprJourneyGhostPreview.css';

/**
 * LprJourneyGhostPreview
 *
 * Shows a screenshot as a ghost preview with an overlay to communicate with users
 * when there is no data or the map is not configured. Helps unfamiliar users
 * understand what the feature looks like and what to do next.
 *
 * Props:
 *   imageSrc       {string}  - path to the preview screenshot
 *   title          {string}  - e.g. "What you'll see"
 *   description    {string}  - explanatory text for the empty state
 *   primaryLabel   {string}  - e.g. "Configure Map"
 *   onPrimaryClick {function} - called when primary CTA is clicked
 *   onHelpClick    {function} - optional; called for "What is LPR Journey?"
 */
const LprJourneyGhostPreview = ({
  imageSrc,
  title,
  description,
  primaryLabel = 'Configure Map',
  onPrimaryClick,
  onHelpClick,
}) => {
  return (
    <div className="lpr-ghost-preview">
      <div className="lpr-ghost-preview-image-wrap">
        <img
          src={imageSrc}
          alt=""
          className="lpr-ghost-preview-img"
          role="presentation"
        />
        <div className="lpr-ghost-preview-overlay" />
      </div>
      <div className="lpr-ghost-preview-content">
        <h4 className="lpr-ghost-preview-title">{title}</h4>
        <p className="lpr-ghost-preview-desc">{description}</p>
        <div className="lpr-ghost-preview-actions">
          {onPrimaryClick && (
            <button
              className="lpr-ghost-preview-btn lpr-ghost-preview-btn--primary"
              onClick={onPrimaryClick}
            >
              <Settings size={14} />
              {primaryLabel}
            </button>
          )}
          {onHelpClick && (
            <button
              className="lpr-ghost-preview-btn lpr-ghost-preview-btn--secondary"
              onClick={onHelpClick}
            >
              <HelpCircle size={14} />
              What is LPR Journey?
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default LprJourneyGhostPreview;
